import { Link } from "react-router-dom";
import Top from "./Top";
import Right from "./Right";
import { useEffect, useState } from "react";
import { getUserFromToken } from "../../function";
import { useDispatch, useSelector } from "react-redux";
import { fetchEventsByUserId } from "../../redux/eventSlice";
import { QRCodeCanvas } from "qrcode.react";
import { fetchSharedEvents } from "../../redux/sharedEventsSlice";
import { server } from "../../server";
import html2pdf from "html2pdf.js";

function AllEvents() {
  const dispatch = useDispatch();
  const { events, loading, error } = useSelector((state) => state.events);
  const { sharedEvents } = useSelector((state) => state.sharedEvents);
  const user = getUserFromToken();
  const userId = user?._id;
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [askPin, setAskPin] = useState(true);
  const [copiedField, setCopiedField] = useState(null);
  const [imageType, setImageType] = useState("compressed");
  const [imageScope, setImageScope] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const eventsPerPage = 5;
  const totalPages = Math.ceil(events.length / eventsPerPage);
  const startIndex = (currentPage - 1) * eventsPerPage;
  const currentEvents = events.slice(startIndex, startIndex + eventsPerPage);
  const [shortUrl, setShortUrl] = useState("");
  const [shortening, setShortening] = useState(false);
  const [eventToDelete, setEventToDelete] = useState(null);

  const [viewMode, setViewMode] = useState(() => {
    return localStorage.getItem("viewMode") || "list";
  });

  useEffect(() => {
    localStorage.setItem("viewMode", viewMode);
  }, [viewMode]);

  const handleDeleteEvent = async () => {
    if (!eventToDelete) return;

    try {
      const token = localStorage.getItem("token");

      const res = await fetch(
        `${server}/Event/DeleteEvent?eventId=${eventToDelete.eventId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: token,
          },
        },
      );

      dispatch(fetchEventsByUserId(userId));
      document.querySelector("#deleteModal .btn-close-modal")?.click();
      dispatch(fetchEventsByUserId(userId));
      dispatch(fetchSharedEvents());
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  const shortenLink = async (url) => {
    try {
      setShortening(true);
      const res = await fetch(
        `https://tinyurl.com/api-create.php?url=${encodeURIComponent(url)}`,
      );
      const short = await res.text();
      setShortUrl(short);
    } catch (err) {
      console.error("URL shortening failed:", err);
      setShortUrl("");
    } finally {
      setShortening(false);
    }
  };

  const shareLink = selectedEvent
    ? `https://visualaey.com/shared/${selectedEvent.eventId}${
        !askPin ? `/${selectedEvent.pin}` : ""
      }/${imageType}/${imageScope}`
    : "";

  useEffect(() => {
    if (selectedEvent) {
      shortenLink(shareLink);
    }
  }, [shareLink]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleCopy = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    setTimeout(() => setCopiedField(null), 500);
  };

  useEffect(() => {
    if (userId) {
      dispatch(fetchEventsByUserId(userId));
      dispatch(fetchSharedEvents());
    }
  }, [userId, dispatch]);

  const allEvents = [
    ...(events || []).map((e) => ({ ...e, type: "created" })),
    ...(sharedEvents || []).map((e) => ({ ...e, type: "shared" })),
  ];

  const sortedEvents = allEvents.sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
  );

  return (
    <>
      <main>
        <Top />

        <div className="container">
          <div className="row g-3">
            <div className="col-lg-9 col-12 py-2">
              <section class="position-relative z-1">
                <div className="pb-2 d-flex flex-column flex-md-row gap-0 align-items-md-center justify-content-between">
                  <div>
                    <h1 className="mb-0 h4 text-light lh-1 fw-medium">
                      My / Shared Events
                    </h1>
                    <nav aria-label="breadcrumb" className="m-0">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <span>Home</span>
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                        >
                          Events
                        </li>
                      </ol>
                    </nav>
                  </div>

                  <div className="col-lg-7 col-12 d-flex justify-content-between justify-content-lg-end mt-lg-0 mt-3">
                    <div className="d-flex justify-content-end align-items-center me-2 bg-light rounded-3">
                      <button
                        className="btn border-0 px-3 fs-6"
                        onClick={() =>
                          setViewMode(viewMode === "list" ? "grid" : "list")
                        }
                      >
                        <i
                          className={`bi ${
                            viewMode === "list"
                              ? "bi-grid-3x3-gap"
                              : "bi-list-ul"
                          }`}
                        ></i>
                      </button>
                    </div>

                    <form class="d-flex align-items-center">
                      <div className="d-flex align-items-center">
                        <span class="position-absolute ps-3 search-icon">
                          <i class="bi bi-search"></i>
                        </span>
                        <input
                          type="search"
                          class="form-control ps-6 normal-text border-0 bg-card-dark rounded-3"
                          placeholder="Search Events"
                        />
                      </div>
                      <Link
                        to="/create-event"
                        className="btn btn-dark-primary border-0 px-4 rounded-3 fs-6 fw-medium ms-2"
                      >
                        Create
                      </Link>
                    </form>
                  </div>
                </div>
              </section>

              <section class="position-relative z-1 pt-2 pb-3">
                {currentEvents.length === 0 ? (
                  <div className="d-flex align-items-center py-2">
                    <img src="/assets/images/no-gallary.png" width="200" />
                    <div className="ms-4">
                      <h5 className="text-light lh-1 m-0">No events found</h5>
                      <p className="text-light opacity-75 m-0 lh-sm mt-lg-0 mt-2">
                        You currently have no events, create new event.
                      </p>
                      <Link
                        to="/create-event"
                        className="btn btn-light border-0 px-4 rounded-3 fs-6 fw-medium mt-lg-3 mt-4"
                      >
                        <i className="bi bi-plus-circle me-1"></i> Create Event
                      </Link>
                    </div>
                  </div>
                ) : (
                  <div
                    className={`${
                      viewMode === "grid" ? "row g-2" : "d-flex flex-column"
                    }`}
                  >
                    {sortedEvents.map((event) =>
                      viewMode === "list" ? (
                        <div
                          key={event.id}
                          className="bg-white rounded-4 mb-2 overflow-hidden"
                        >
                          <div className="row">
                            <div className="col-lg-4 col-5">
                              <div className="position-relative">
                                <Link to="/event" state={{ event }}>
                                  <img
                                    src={
                                      event.eventPhoto ||
                                      "/assets/images/default.png"
                                    }
                                    className="w-100 rounded-4 object-fit-cover"
                                    height="190"
                                    alt={event.name}
                                  />
                                </Link>
                                <div className="position-absolute bottom-0 left-0 p-3">
                                  <span
                                    className={`badge px-3 rounded-pill smtext ${
                                      event.type === "shared"
                                        ? "text-bg-primary"
                                        : "text-bg-success"
                                    }`}
                                  >
                                    {event.type === "shared"
                                      ? "Shared"
                                      : "Created"}
                                  </span>
                                  <span
                                    className={`badge px-3 rounded-pill smtext ms-1 ${
                                      event.type === "shared"
                                        ? "text-bg-info"
                                        : "text-bg-danger"
                                    }`}
                                  >
                                    {event.category
                                      ? event.category.charAt(0).toUpperCase() +
                                        event.category.slice(1)
                                      : ""}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div className="col-lg-8 col-7 d-flex justify-content-center flex-column p-3 ps-lg-5">
                              <Link to="/event" state={{ event }}>
                                <h4 className="lh-1 ls-sm mb-0">
                                  {event.name}
                                </h4>
                                <span class="text-primary d-block fw-medium mb-2 fs-6">
                                  {event?.totalImages.toLocaleString("en-IN")}{" "}
                                  Photos
                                </span>
                              </Link>
                              <p className="m-0 mb-2 fs-6 ls-sm lh-sm text-truncate pe-4">
                                {event.description}
                              </p>
                              <p className="m-0 fs-6 ls-sm lh-sm">
                                <span className="text-dark">
                                  {new Date(
                                    event.createdAt,
                                  ).toLocaleDateString()}
                                </span>
                                <br />
                                Access:{" "}
                                {event.phones.length > 1
                                  ? `${event.phones[0]} +${
                                      event.phones.length - 1
                                    } more`
                                  : event.phones[0]}
                              </p>

                              <div className="d-flex align-items-center gap-1 mt-3 pt-1">
                                {/* Share button always visible */}
                                <span
                                  type="button"
                                  data-bs-toggle="modal"
                                  data-bs-target="#shareModal"
                                  onClick={() => {
                                    setSelectedEvent(event);
                                    setAskPin(true);
                                  }}
                                  className="action-button rounded-circle"
                                >
                                  <i className="bi bi-share text-light opacity-75"></i>
                                </span>

                                {/* Only show for created events */}
                                {event.type !== "shared" && (
                                  <>
                                    <Link className="action-button rounded-circle">
                                      <i className="bi bi-gear text-light opacity-75"></i>
                                    </Link>
                                    <Link
                                      to="/event"
                                      state={{ event }}
                                      className="action-button rounded-circle"
                                    >
                                      <i className="bi bi-upload text-light opacity-75"></i>
                                    </Link>
                                    <span
                                      type="button"
                                      data-bs-toggle="modal"
                                      data-bs-target="#deleteModal"
                                      className="action-button rounded-circle"
                                      onClick={() => setEventToDelete(event)}
                                    >
                                      <i className="bi bi-trash2 text-light opacity-75"></i>
                                    </span>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="col-lg-4 col-12" key={event.id}>
                          <div className="bg-white rounded-4 overflow-hidden h-100">
                            <div className="position-relative">
                              <Link to="/event" state={{ event }}>
                                <img
                                  src={
                                    event.eventPhoto ||
                                    "/assets/images/default.png"
                                  }
                                  className="w-100 object-fit-cover rounded-4"
                                  height="180"
                                  alt={event.name}
                                />
                              </Link>
                              <div className="position-absolute bottom-0 left-0 p-3">
                                <span
                                  className={`badge px-3 rounded-pill smtext ${
                                    event.type === "shared"
                                      ? "text-bg-primary"
                                      : "text-bg-success"
                                  }`}
                                >
                                  {event.type === "shared"
                                    ? "Shared"
                                    : "Created"}
                                </span>
                                <span
                                  className={`badge px-3 rounded-pill smtext ms-1 ${
                                    event.type === "shared"
                                      ? "text-bg-info"
                                      : "text-bg-danger"
                                  }`}
                                >
                                  {event.category
                                    ? event.category.charAt(0).toUpperCase() +
                                      event.category.slice(1)
                                    : ""}
                                </span>
                              </div>
                            </div>

                            <div className="px-4 py-3 mt-2 d-flex flex-column justify-content-between">
                              <Link to="/event" state={{ event }}>
                                <h4 className="lh-1 ls-sm mb-0">
                                  {event.name}
                                </h4>
                                <span class="text-primary d-block fw-medium mb-2 fs-6">
                                  {event?.totalImages.toLocaleString("en-IN")}{" "}
                                  Photos
                                </span>
                              </Link>
                              <p className="m-0 mb-2 fs-6 ls-sm lh-sm text-truncate pe-3">
                                {event.description}
                              </p>
                              <p className="m-0 fs-6 ls-sm lh-sm">
                                <span className="text-dark">
                                  {new Date(
                                    event.createdAt,
                                  ).toLocaleDateString()}
                                </span>
                                <br />
                                Access:{" "}
                                {event.phones.length > 1
                                  ? `${event.phones[0]} +${
                                      event.phones.length - 1
                                    } more`
                                  : event.phones[0]}
                              </p>

                              <div className="d-flex mt-3 pt-1 mb-2 gap-1">
                                <span
                                  type="button"
                                  data-bs-toggle="modal"
                                  data-bs-target="#shareModal"
                                  onClick={() => {
                                    setSelectedEvent(event);
                                    setAskPin(true);
                                  }}
                                  className="action-button rounded-circle"
                                >
                                  <i className="bi bi-share text-light opacity-75"></i>
                                </span>

                                {event.type !== "shared" && (
                                  <>
                                    <Link
                                      to="/update-event"
                                      state={{ event }}
                                      className="action-button rounded-circle"
                                    >
                                      <i className="bi bi-gear text-light opacity-75"></i>
                                    </Link>
                                    <Link
                                      to="/event"
                                      state={{ event }}
                                      className="action-button rounded-circle"
                                    >
                                      <i className="bi bi-upload text-light opacity-75"></i>
                                    </Link>
                                    <span
                                      type="button"
                                      data-bs-toggle="modal"
                                      data-bs-target="#deleteModal"
                                      className="action-button rounded-circle"
                                      onClick={() => setEventToDelete(event)}
                                    >
                                      <i className="bi bi-trash2 text-light opacity-75"></i>
                                    </span>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ),
                    )}
                  </div>
                )}

                {totalPages > 1 && (
                  <div className="card-footer mt-4">
                    <nav aria-label="Page navigation">
                      <ul className="pagination justify-content-center mb-0">
                        <li
                          className={`page-item ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage - 1)}
                          >
                            <i className="bi bi-chevron-left"></i>
                          </button>
                        </li>

                        {Array.from({ length: totalPages }, (_, i) => (
                          <li
                            key={i}
                            className={`page-item ${
                              currentPage === i + 1 ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(i + 1)}
                            >
                              {i + 1}
                            </button>
                          </li>
                        ))}

                        <li
                          className={`page-item ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage + 1)}
                          >
                            <i className="bi bi-chevron-right"></i>
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}
              </section>
            </div>

            <div className="col-lg-3 col-12">
              <Right />
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="deleteModal"
          tabIndex="-1"
          aria-labelledby="deleteModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-md modal-dialog-centered">
            <div className="modal-content rounded-4">
              <div className="modal-body py-0 ps-5">
                <div className="d-flex justify-content-end mt-n8">
                  <img src="/assets/images/trash.png" width="140" />
                </div>
                <div className="mt-n7">
                  <h4 className="ls-sm mb-3">
                    <i className="bi bi-trash"></i> &nbsp; Delete Event
                  </h4>
                  <div>
                    <p className="fs-5 lh-sm text-dark mb-1">
                      Are you sure you want to delete this event?
                    </p>
                    <p className="fs-6 lh-sm mt-2">
                      If this event is deleted,{" "}
                      <span className="fw-medium text-danger">
                        you will not be able to recover
                      </span>{" "}
                      its details or
                      <br />
                      any images uploaded under it.
                    </p>
                  </div>

                  <button
                    onClick={handleDeleteEvent}
                    className="btn btn-dark-primary border-0 px-4 rounded-3 fs-6 fw-medium mt-3"
                  >
                    Delete
                  </button>
                </div>
              </div>

              <div className="modal-footer border-0 p-0">
                <button
                  type="button"
                  className="btn btn-success rounded-circle px-3 label-text text-white btn-close-modal me-n3 mb-n2"
                  data-bs-dismiss="modal"
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="shareModal"
          tabIndex="-1"
          aria-labelledby="shareModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content rounded-4">
              {selectedEvent ? (
                <>
                  <div className="modal-body pt-0 pb-1">
                    <div className="d-flex justify-content-end mt-n8">
                      <img src="/assets/images/rocket.svg" width="140" />
                    </div>
                    <div className="mt-n8">
                      <h4 className="ls-sm mb-3">
                        <i className="bi bi-share"></i> &nbsp; Share Links
                      </h4>

                      <div className="col-12">
                        <label className="label-text mb-1 ms-3">
                          Access via PIN
                        </label>
                        <div className="d-flex justify-content-center align-items-center">
                          <input
                            type="text"
                            className="form-control ps-3 normal-text bg-white border border-light rounded-3"
                            value={`https://visualaey.com/shared/${
                              selectedEvent.eventId
                            }${
                              !askPin ? `/${selectedEvent.pin}` : ""
                            }/${imageType}/${imageScope}`}
                            readOnly
                          />
                          <i
                            className={`ms-3 fs-3 cursor-pointer bi ${
                              copiedField === "link"
                                ? "bi-check-circle text-success"
                                : "bi-copy"
                            }`}
                            onClick={() =>
                              handleCopy(
                                `https://visualaey.com/shared/${
                                  selectedEvent.eventId
                                }${
                                  !askPin ? `/${selectedEvent.pin}` : ""
                                }/${imageType}/${imageScope}`,
                                "link",
                              )
                            }
                          />
                        </div>
                        <p className="smtext m-0 ms-3 me-5 mt-1 lh-1 text-secondary">
                          People with this link can see Only this event photos.
                        </p>

                        <div className="d-flex align-items-center mt-3">
                          <label className="label-text mb-1 ms-3 me-3">
                            Event PIN
                          </label>
                          <input
                            type="text"
                            className="form-control ps-3 normal-text bg-white border border-light rounded-3 w-15"
                            value={selectedEvent.pin}
                            readOnly
                          />
                          <div className="d-flex align-items-center">
                            <i
                              className={`ms-3 fs-3 cursor-pointer bi ${
                                copiedField === "pin"
                                  ? "bi-check-circle text-success"
                                  : "bi-copy"
                              }`}
                              onClick={() =>
                                handleCopy(selectedEvent.pin, "pin")
                              }
                            />
                            <div className="form-check form-switch ms-5">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="checkNativeSwitch"
                                checked={!askPin}
                                onChange={() => setAskPin(!askPin)}
                              />
                              <label
                                className="form-check-label fs-6 text-secondary fw-normal"
                                htmlFor="checkNativeSwitch"
                              >
                                Do not Ask PIN
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex align-items-center">
                          <div className="d-flex flex-column align-items-start mt-2">
                            <div className="d-flex align-items-center">
                              <QRCodeCanvas
                                value={`https://visualaey.com/shared/${
                                  selectedEvent.eventId
                                }${
                                  !askPin ? `/${selectedEvent.pin}` : ""
                                }/${imageType}/${imageScope}`}
                                size={80}
                                bgColor="#ffffff"
                                fgColor="#000000"
                                level="H"
                                includeMargin={true}
                              />
                              <div className="d-flex flex-column ms-2">
                                <button
                                  className="btn btn-outline-dark btn-sm rounded-3 mb-1 px-4"
                                  onClick={async () => {
                                    // 1️⃣ Generate a fresh HIGH-RES QR canvas (600px instead of 80px)
                                    const { QRCodeCanvas: QRCanvas } =
                                      await import("qrcode.react");

                                    const qrSize = 600; // high-res source
                                    const tempDiv =
                                      document.createElement("div");
                                    tempDiv.style.position = "fixed";
                                    tempDiv.style.top = "-9999px";
                                    document.body.appendChild(tempDiv);

                                    const { createRoot } =
                                      await import("react-dom/client");
                                    const root = createRoot(tempDiv);

                                    await new Promise((resolve) => {
                                      root.render(
                                        <QRCanvas
                                          value={`https://visualaey.com/shared/${selectedEvent.eventId}${
                                            !askPin
                                              ? `/${selectedEvent.pin}`
                                              : ""
                                          }/${imageType}/${imageScope}`}
                                          size={qrSize}
                                          bgColor="#ffffff"
                                          fgColor="#000000"
                                          level="H"
                                          includeMargin={true}
                                        />,
                                      );
                                      setTimeout(resolve, 300); // wait for render
                                    });

                                    const qrCanvas =
                                      tempDiv.querySelector("canvas");
                                    const qrDataUrl = qrCanvas.toDataURL(
                                      "image/png",
                                      1.0,
                                    );

                                    root.unmount();
                                    document.body.removeChild(tempDiv);

                                    // 2️⃣ Build PDF element
                                    const element =
                                      document.createElement("div");
                                    element.innerHTML = `
                                      <div style="
                                        margin: auto;
                                        padding: 30px;
                                        font-family: Arial, sans-serif;
                                        color:#333;
                                        box-sizing: border-box;
                                        word-break: break-word;
                                      ">
                                        <div style="display:flex; justify-content:space-between; align-items:center;">
                                          <div>
                                            <img src="/assets/images/pdf-logo.png" style="height:45px;" />
                                            <p style="font-size:12px; color:#666; margin:0;">Scan & access event photos instantly</p>
                                          </div>
                                          <div style="text-align:right;">
                                            <h3 style="margin:0;">EVENT QR</h3>
                                            <p style="font-size:12px; margin:5px 0;">${new Date().toLocaleDateString()}</p>
                                          </div>
                                        </div>

                                        <hr style="margin:20px 0;" />

                                        <div style="text-align:center;">
                                          <h1 style="margin-bottom:3px; font-size:24px; line-height:1.3;">${selectedEvent.name}</h1>
                                          <p style="color:#666; font-size:14px; line-height:1.2;">
                                            ${selectedEvent.description || "Event Photos Access"}
                                          </p>
                                        </div>

                                        <div style="
                                          margin:30px auto;
                                          width:100%;
                                          max-width:380px;
                                          padding:20px;
                                          border:1px solid #eee;
                                          border-radius:12px;
                                          text-align:center;
                                          box-shadow:0 4px 15px rgba(0,0,0,0.05);
                                        ">
                                          <img src="${qrDataUrl}" style="
                                            width:260px;
                                            height:260px;
                                            image-rendering: pixelated;
                                          " />
                                          <p style="margin-top:12px; font-size:14px;">
                                            Scan to View Event Photos / 
                                            <a href="${`https://visualaey.com/shared/${selectedEvent.eventId}${
                                              !askPin ? `/${selectedEvent.pin}` : ""
                                            }/${imageType}/${imageScope}`}">Click Here</a>
                                          </p>
                                        </div>

                                        <div style="margin-top:20px;">
                                          <h4>Event Details</h4>
                                          <p style="font-size:14px; line-height:1.6;">
                                            📅 Created: ${new Date(selectedEvent.createdAt).toLocaleDateString()}<br/>
                                            🔒 Access: ${askPin ? "PIN Required" : "Direct Access"}<br/>
                                            🖼 Image Type: ${imageType}<br/>
                                            📂 Scope: ${imageScope}
                                          </p>
                                        </div>

                                        <div style="margin-top:20px;">
                                          <h4>How to Access</h4>
                                          <ol style="font-size:14px; line-height:1.6; padding-left:18px;">
                                            <li>Scan the QR code</li>
                                            <li>${askPin ? "Enter event PIN if prompted" : "Directly open link"}</li>
                                            <li>View & download photos 🎉</li>
                                          </ol>
                                        </div>

                                        <div style="margin-top:40px; text-align:center; font-size:12px; color:#777;">
                                          <p style="margin:0;">Powered by Visualaey</p>
                                          <p style="margin:0;">This QR is generated securely for event sharing</p>
                                        </div>
                                      </div>
                                    `;

                                    document.body.appendChild(element);

                                    await html2pdf()
                                      .set({
                                        margin: 10,
                                        filename: `${selectedEvent.name}-QR.pdf`,
                                        image: { type: "png", quality: 1 }, // PNG instead of JPEG — no compression artifacts
                                        html2canvas: {
                                          scale: 4, // max sharpness
                                          useCORS: true,
                                          letterRendering: true,
                                        },
                                        jsPDF: {
                                          unit: "mm",
                                          format: "a4",
                                          orientation: "portrait",
                                        },
                                      })
                                      .from(element)
                                      .save();

                                    document.body.removeChild(element);
                                  }}
                                >
                                  <i className="bi bi-download me-1"></i>{" "}
                                  Download QR
                                </button>

                                <button
                                  className="btn btn-outline-primary btn-sm rounded-3"
                                  onClick={() => {
                                    navigator.clipboard.writeText(
                                      `https://visualaey.com/shared/${
                                        selectedEvent.eventId
                                      }${
                                        !askPin ? `/${selectedEvent.pin}` : ""
                                      }/${imageType}/${imageScope}`,
                                    );
                                    setCopiedField("qr");
                                    setTimeout(
                                      () => setCopiedField(null),
                                      1000,
                                    );
                                  }}
                                >
                                  <i
                                    className={`bi ${
                                      copiedField === "qr"
                                        ? "bi-check-circle"
                                        : "bi-qr-code"
                                    } me-1`}
                                  ></i>
                                  Copy Link
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex align-items-center mt-3">
                          <div className="border border-light rounded-3 d-flex align-items-center col-8 overflow-hidden">
                            {["compressed", "watermarked", "original"].map(
                              (type) => (
                                <div
                                  key={type}
                                  className={`col-4 border-end text-center p-1 cursor-pointer ${
                                    imageType === type
                                      ? "bg-dark-soft text-dark"
                                      : ""
                                  }`}
                                  onClick={() => setImageType(type)}
                                >
                                  <p className="m-0 normal-text text-capitalize">
                                    {type}
                                  </p>
                                </div>
                              ),
                            )}
                          </div>
                          <p className="smtext m-0 ms-3 me-5 lh-sm text-secondary">
                            Select quality of event's image you want to share.
                          </p>
                        </div>

                        <div className="d-flex align-items-center mt-1">
                          <div className="border border-light rounded-3 d-flex align-items-center col-6 overflow-hidden">
                            {[
                              { label: "All Images", value: "all" },
                              { label: "Self Images", value: "self" },
                            ].map((opt) => (
                              <div
                                key={opt.value}
                                className={`col-6 text-center p-1 cursor-pointer ${
                                  imageScope === opt.value
                                    ? "bg-dark-soft text-dark"
                                    : ""
                                }`}
                                onClick={() => setImageScope(opt.value)}
                              >
                                <p className="m-0 normal-text">{opt.label}</p>
                              </div>
                            ))}
                          </div>
                        </div>
                        <p className="smtext m-0 ms-3 me-5 mt-1 lh-sm text-secondary">
                          Share all images or own images.
                        </p>
                      </div>

                      <hr />

                      <div className="col-12 mt-3">
                        <label className="label-text mb-1 ms-3">
                          Access via Phone No
                        </label>
                        <div className="d-flex justify-content-center align-items-center">
                          <input
                            type="text"
                            className="form-control ps-3 normal-text bg-white border border-light rounded-3"
                            value={`https://visualaey.com/login/${selectedEvent.eventId}/access`}
                            readOnly
                          />
                          <i
                            className={`ms-3 fs-3 cursor-pointer bi ${
                              copiedField === "phone"
                                ? "bi-check-circle text-success"
                                : "bi-copy"
                            }`}
                            onClick={() =>
                              handleCopy(
                                `https://visualaey.com/login/${selectedEvent.eventId}/access`,
                                "phone",
                              )
                            }
                          />
                        </div>
                        <p className="smtext m-0 ms-3 me-5 mt-1 lh-sm text-secondary">
                          People with this link can see this event photos Only
                          <br />
                          if their Phone No. is added to this event.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="modal-footer border-0 p-0">
                    <button
                      type="button"
                      className="btn btn-success rounded-circle px-3 label-text text-white btn-close-modal me-n3 mb-n2"
                      data-bs-dismiss="modal"
                    >
                      <i className="bi bi-x-lg"></i>
                    </button>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default AllEvents;
